<label [class.checked]="check && element.available" [ngClass]="{disabled:!element.available}">
    <input type="checkbox" [attr.disabled]="!element.available ? '' : null" [(ngModel)]="check" [name]="name"
        (change)="change()">
    <!-- <div style="white-space: pre-wrap;color: black;">
        {{element.name}} {{element.size}} ( {{element.price}} € )
        <span *ngIf="!element.available" class="indisponible">
            indisponible
        </span>
    </div> -->
    <span class="icon">
        <i class="flaticon-exclamation" *ngIf="!element.available"></i>
        <svg *ngIf="element.available" width="12px" height="10px" viewbox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
        </svg>
    </span>
    <span class="lab" *ngIf="element.available">{{element.name}} {{element.size}} ( {{element.price}} € )</span>
    <span class="lab" *ngIf="!element.available" class="indisponible">
        indisponible
    </span>
</label>